// Artemis step Results come PascalCase (the guide's "Step results"); the Hunt Planner's readers in
// unit-info/unitInfo.js take the services API's camelCase. camelKeys turns one into the other so a
// card can reuse those readers instead of a second copy. Values are left alone, so blobs the guide
// says to pass on as data (LandOwnership, Properties…) must not go through it.

const camel = key => (typeof key === 'string' && /^[A-Z]/.test(key) ? key.charAt(0).toLowerCase() + key.slice(1) : key)

export const camelKeys = value => {
  if (Array.isArray(value)) return value.map(camelKeys)
  if (!value || typeof value !== 'object') return value
  return Object.fromEntries(Object.entries(value).map(([k, v]) => [camel(k), camelKeys(v)]))
}
